import type { Workflow, WorkflowKind, WorkflowStep } from "@/types/workflow.types";
import { AGENTIC_STEP_TYPES } from "@/types/workflow.types";

export function deriveWorkflowKind(steps: WorkflowStep[] = []): WorkflowKind {
  let hasAgentic = false;
  let hasEtl = false;

  for (const step of steps) {
    if (AGENTIC_STEP_TYPES.has(step.stepType)) hasAgentic = true;
    else hasEtl = true;
    if (hasAgentic && hasEtl) return "mixed";
  }

  return hasAgentic ? "agentic" : "etl";
}

export function getWorkflowKind(
  workflow: Pick<Workflow, "kind" | "steps">,
): WorkflowKind {
  return workflow.kind ?? deriveWorkflowKind(workflow.steps ?? []);
}

export function workflowRequiresAgenticRuntime(
  workflow: Pick<Workflow, "kind" | "steps">,
): boolean {
  const kind = getWorkflowKind(workflow);
  if (kind === "agentic" || kind === "mixed") return true;
  return (workflow.steps ?? []).some((step) => AGENTIC_STEP_TYPES.has(step.stepType));
}
